<span class="avatar-pill" 
  [class.removal-mode]="removalMode"
  [class.clickable]="clickable"
  [class.disabled]="disabled"
  [class.active]="active"
  [class.cursor-none]="cursorNone"
  [class.compact]="compact"
  [class.no-background]="hideBackground"
  (click)="onSelected()">
  <img class="profile-img" [src]="imageUrl ? imageUrl : fallbackImageUrl" [alt]="text">
  <span *transloco="let t">{{translationKey ? t(translationKey) : text ? text : t(fallbackTranslationKey)}}</span>

  @if (removalMode) {
    <button type="button" aria-label="Remove" class="btn btn-dismiss py-0">
      <i class="fa-solid fa-xmark"></i>
    </button>
  }

</span>

<!-- <span class="avatar-pill">
<img class="profile-img" src="" alt="...">
<span>...</span>
</span>

<span class="avatar-pill removal-mode">
  <img class="profile-img" src="" alt="...">
  <span>...</span>

  <button type="button" aria-label="Remove" class="btn-dismiss">
    <i class="fa-solid fa-xmark"></i>
  </button>
</span>

<span class="avatar-pill disabled">
  <img class="profile-img" src="" alt="...">
  <span>...</span>
</span> -->